import {useSelector, shallowEqual} from 'react-redux';
import HeaderWithProfile from '@jobseeker/feature-navigation/widgets/HeaderProfile';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';

import type {AppState} from '@jobseeker/common-core/types';

const HeaderProfileHarness = () => {
  const interceptor: any = useInterceptor();
  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const isUserLogin: boolean = useSelector(
    (state: AppState) => state.auth.isLoggedIn,
    shallowEqual
  );

  const {
    siteName,
    header: {config, meta},
    proMembership,
  } = interceptor;

  return (
    <HeaderWithProfile
      siteName={siteName}
      config={config}
      meta={meta}
      isLoggedIn={isUserLogin}
      page={page}
      subscriptionMeta={proMembership}
    />
  );
};

export default HeaderProfileHarness;
